import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {POST_TRANSACTION_LOG_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PostTransactionLogRequest {
  auditActionType: string;
  applicationId?: string | null;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void, reqData: PostTransactionLogRequest) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostTransactionLog = ({onSuccess, onError}: Input = {}) => {
  const postTransactionLog = async (reqBody: PostTransactionLogRequest) => {
    await axiosClient.post(POST_TRANSACTION_LOG_URL, reqBody);
  };

  return useCustomMutation(postTransactionLog, {
    onSuccess,
    onError,
  });
};
